import preset from '@/@core/preset/preset'
import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
  preset,
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    options: {
      customProperties: true,
      variations: false,
    },
    themes: {
      light: {
        purple: colors.deepPurple.darken3,
      },
      dark: {
        purple: colors.deepPurple.darken3,
      },
    },
  },
})
